class AdminNotificationDatatable {
    constructor(categoryName, allAdmins, datatableEl, currentTabEl, wrapperEl){
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = null;
        this.datatableEl = datatableEl;
        this.currentTabEl = currentTabEl;
        this.categoryName = categoryName;
        this.allAdmins = allAdmins;
        this.wrapperEl = wrapperEl;
        this.addAdminsButton = this.currentTabEl.querySelector('button[data-bs-action="add-admins"]');

        this.initDatatable();
        this.initAddAdmins();
        this.initActions();
    }
    async initDatatable() {
        let thisClass = this;
        this.datatable = $(thisClass.datatableEl).DataTable({
            ajax: async function (data, callback, settings) {
                let selectedAdmins = (await thisClass.getSelectedAdminsByCategory()).selectedAdmins;
                if (selectedAdmins.length > 0) {
                    thisClass.currentTabEl.querySelector('#'+thisClass.datatableEl.id+'_wrapper').classList.remove('d-none');
                    thisClass.currentTabEl.querySelector('#'+thisClass.datatableEl.id+'_no-results').classList.add('d-none');
                } else {
                    thisClass.currentTabEl.querySelector('#'+thisClass.datatableEl.id+'_wrapper').classList.add('d-none');
                    thisClass.currentTabEl.querySelector('#'+thisClass.datatableEl.id+'_no-results').classList.remove('d-none');
                }
                callback({
                    data: selectedAdmins
                });
            },
            order: [[1, 'desc']],
            processing: true,
            serverSide: false,
            stateSave: false,
            info: true,
            paging: true,
            language: {
                emptyTable: "No data found"
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function (settings) {
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=a' + thisClass.datatableEl.name + '_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'value',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">\n' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="#'+thisClass.datatableEl.id+' .form-check-input" data-kt-check-all="true" value="1"/>\n' +
                        '   </div>',
                    class: 'py-1 mw-25px',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">' +
                            '    <input class="form-check-input cursor-pointer" type="checkbox" name="admins[]" value="' + row['value'] + '"/>' +
                            '</div>';
                    }
                },
                {
                    data: 'name',
                    title: 'Recipient',
                    sortable: true,
                    render: function (data, type, row) {
                        let avatar = '<img src="/media/goodaccess/avatars/svg/Icon with face-' + row['avatarID'] + '.svg" alt="avatar">';
                        if(row['value'] === 'all'){
                            avatar = 'All';
                        }

                        let avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['avatarID'] + '.svg';
                        if (row['accepted']) {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white text-primary' + (row['isBlocked'] === 1 ? ' filter-grayscale' : '') + '">' +
                                (row['avatarID'] ? avatar : '<i class="fa-solid fa-user-clock fs-1"></i>') +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>' + (row['isIdentityBlocked'] ? 'Identity is disabled' : 'blocked') + '</div>">&#10005;</span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div id="' + row['value'] + '"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 ' + (row['edit'] && row['roleID'] !== 4 ? 'edit-manager' : '') + '" data-manager-name="' + row['name'] + '">' + (row['name'] ? row['name'] : 'invited') + '</span>' +(row['nameDescription'] ? '<i class="fa-regular fa-circle-question ms-2 cursor-help" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Includes Admins & Roles: '+row['nameDescription']+'"></i>' : '') + (row['meBadge'] ? '<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>' : '') + '<span class="badge badge-light-danger ms-2">' + row['roleName'] + '</span></div>' +
                                '           <div class="d-flex align-items-center">' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['email'] + '</span>' +
                                '           </div>' +
                                '       </div>' +
                                '   </div>';
                        } else {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px symbol-circle border ga-border-primary-300 me-3">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white text-primary' + (row['isBlocked'] === 1 ? ' filter-grayscale' : '') + '">' +
                                (row['avatarID'] ? avatar : '<i class="fa-solid fa-user-clock fs-1"></i>') +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>' + (row['isIdentityBlocked'] ? 'Identity is disabled' : 'blocked') + '</div>">&#10005;</span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '            <div id="' + row['value'] + '"><span class="fw-bold text-primary mb-1 fs-6"><span>invited</span></span></div>' +
                                '           <div class="d-flex align-items-center">' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['email'] + '</span>' +
                                '        </div>' +
                                '       </div>' +
                                '   </div>';
                        }
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="' + row['value'] + '">';
                        if (row['editSettings']) {
                            html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-admin cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">' +
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html + '</div>';
                    }
                }
            ]
        }).on('select', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows === displayedRows){
                $('#'+thisClass.datatableEl.id+'_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows !== displayedRows){
                $('#'+thisClass.datatableEl.id+'_wrapper [data-kt-check-all]').prop('checked', false);
            }
        }).on('draw', function () {
            $('#'+thisClass.datatableEl.id+'_wrapper [data-kt-check-all]').prop('checked', false);
            thisClass.removeSelectedRows();
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(this.datatable, '[data-kt-docs-table-filter=search]');
    }
    initActions(){
        const thisClass = this;

        $(document).on('click','#'+thisClass.datatableEl.id+'_wrapper [data-kt-check-all]',function(e){
            if ($(this).is(':checked')) {
                thisClass.datatable.rows().select();
            } else {
                thisClass.datatable.rows().deselect();
            }
        });

        $(document).on('click','#'+thisClass.datatableEl.id+' .delete-admin',function(e){
            let adminID = $(this).parent()[0].id;
            let row = $(this).closest('tr');
            let managerName = '';
            managerName = row.find('span[data-manager-name]').attr('data-manager-name');
            if(managerName === undefined){
                managerName = row.find('span[data-manager-username]').attr('data-manager-username');
            }
            let html = `<div class="text-center text-primary">You are about to remove `+(managerName !== undefined ? `<b>`+managerName+`</b>` : `Admin`)+` from recipient list!</div>`;
            Swal.fire({
                html: html,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, remove!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/notifications?do=removeAdminsFromNotification&organizationID='+thisClass.organizationID+'&adminIDs='+adminID+'&categoryName='+thisClass.categoryName)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Admin has been removed from recipient list.');
                        thisClass.reloadData();
                    }
                }
            });
        });
    }
    async reloadData() {
        let selectedAdmins = (await this.getSelectedAdminsByCategory()).selectedAdmins;
        if (selectedAdmins.length > 0) {
            this.datatable.clear().rows.add(selectedAdmins).draw();
            this.currentTabEl.querySelector('#'+this.datatableEl.id+'_wrapper').classList.remove('d-none');
            this.currentTabEl.querySelector('#'+this.datatableEl.id+'_no-results').classList.add('d-none');
        } else {
            this.datatable.clear().draw();
            this.currentTabEl.querySelector('#'+this.datatableEl.id+'_wrapper').classList.add('d-none');
            this.currentTabEl.querySelector('#'+this.datatableEl.id+'_no-results').classList.remove('d-none');
        }
    }
    async getSelectedAdminsByCategory() {
        const thisClass = this;
        const response = await fetch('/notifications/?do=getSelectedAdminsByCategory&organizationID=' + thisClass.organizationID+'&categoryName=' + thisClass.categoryName);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        this.allAdmins = await this.allAdmins;

        // Admins who are in selectedAdmins
        const selectedAdmins = this.allAdmins.filter(admin =>
            data.selectedAdmins.includes(admin.value)
        );

        // Admins that are in canSelectAdmins and NOT in selectedAdmins
        const selectableAdmins = this.allAdmins.filter(admin =>
            data.canSelectAdmins.includes(admin.value) &&
            !data.selectedAdmins.includes(admin.value)
        );

        // Disable add button if there is no admin to add
        if(this.addAdminsButton){
            this.addAdminsButton.disabled = selectableAdmins.length === 0;
        }

        return {
            selectedAdmins: selectedAdmins,
            selectableAdmins: selectableAdmins,
        }
    }
    initAddAdmins(){
        let thisClass = this;
        if(this.addAdminsButton){
            this.addAdminsButton.addEventListener('click', async function () {
                new ModalLoading();
                let selectableAdmins = (await thisClass.getSelectedAdminsByCategory()).selectableAdmins;

                let addAdminsModal = document.querySelector('#add_admins_to_notifications_modal');
                addAdminsModal.parentElement.querySelector('input[name="categoryName"]').value = thisClass.categoryName;

                let adminsInput = addAdminsModal.querySelector('input[name="adminsToAdd"]');
                if(adminsInput.__tagify){
                    adminsInput.__tagify.destroy();
                }
                let adminsTagify = new AdminsTagify(adminsInput, selectableAdmins);
                adminsTagify.on('add', function(e, tagData){
                    const addedValue = e.detail.data.value;
                    adminsTagify.getTagElms().forEach(tag => {
                        if (addedValue === 'all' && tag.attributes.value.value !== 'all') {
                            adminsTagify.removeTag(tag);
                        } else if(addedValue !== 'all' && tag.attributes.value.value === 'all'){
                            adminsTagify.removeTag(tag);
                        }
                    });
                });

                new ModalLoading(addAdminsModal);
            });
        }
    }
    removeSelectedRows(){
        const thisClass = this;
        // Select all checkboxes
        const checkboxes = this.wrapperEl.querySelectorAll('[type="checkbox"]');
        // Select elements
        const deleteSelected = this.wrapperEl.querySelector('[data-kt-docs-table-select="delete_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function () {
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Deleted selected rows
        if(deleteSelected){
            deleteSelected.addEventListener('click', function () {
                let selectedIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to remove selected Admins?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, remove!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/notifications?do=removeAdminsFromNotification&organizationID='+thisClass.organizationID+'&adminIDs='+selectedIDs+'&categoryName='+thisClass.categoryName)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = thisClass.datatableEl.querySelector('thead [type="checkbox"]');
                        headerCheckbox.checked = false;
                        thisClass.wrapperEl.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        thisClass.wrapperEl.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');

                        if(result.value === 'deleted') {
                            toastr.success('Admins has been removed from recipient list.');
                            thisClass.reloadData();
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const toolbarBase = this.wrapperEl.querySelector('[data-kt-docs-table-toolbar="base"]');
        const toolbarSelected = this.wrapperEl.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarBase && toolbarSelected){
            const selectedCount = this.wrapperEl.querySelector('[data-kt-docs-table-select="selected_count"]');

            // Select refreshed checkbox DOM elements
            const allCheckboxes = this.datatableEl.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarBase.classList.add('d-none');
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarBase.classList.remove('d-none');
                toolbarSelected.classList.add('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Select refreshed checkbox DOM elements
        const allCheckboxes = this.datatableEl.querySelectorAll('tbody [type="checkbox"]');

        let adminIDs = [];
        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                adminIDs.push(c.value);
            }
        });
        return adminIDs;
    }
}
window.AdminNotificationDatatable = AdminNotificationDatatable;